import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgotPassword/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Toast
import toastReducer from "./toast/reducer";

// Dashboard
import DashboardReducer from "./dashboard/reducer";

// Users
import UsersReducer from "./users/reducer";

// Farmhouse
import FarmhouseReducer from "./farmhouse/reducer";
// Bookings
import BookingsReducer from "./bookings/reducer";

// Static Pages
import StaticPagesReducer from "./staticPages/reducer";

// Settings
import SettingsReducer from "./settings/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  toast: toastReducer,
  Dashboard: DashboardReducer,
  Users: UsersReducer,
  Farmhouse: FarmhouseReducer,
  Bookings: BookingsReducer,
  StaticPages: StaticPagesReducer,
  Settings: SettingsReducer,
});

export default rootReducer;
